module.exports = __webpack_public_path__ + "3ad872b73fa945557e773c0683b967ec.svg";